var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user && !_vm.user.has_email)?_c('b-alert',{attrs:{"type":"info","message":_vm.readOnlyRules
                ? _vm.t('default::title.email_remainder_not_permitted')
                : _vm.t('default::title.add_email_remainder'),"has-header-button":!_vm.readOnlyRules,"button-title":_vm.t('default::title.add_email_remainder.go_to_profile_link')},on:{"emitAction":function($event){return _vm.gotToProfile()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }